import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Drawer, Avatar } from 'antd';
import Sidebar, { SidebarContent } from '../SideBar';
import Header from '../Header';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../authContext/AuthContext';
import { Noti } from '../Noti/toast';
import './style.scss';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  const toggleSidebarCollapse = () => setSidebarCollapsed(!isSidebarCollapsed);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    logout();
    Noti('success', 'Logout success', 3000);
    closeSidebar();
    navigate('/login');
  };

  return (
    <div className="app-container">
      {/* Desktop Sidebar */}
      <div className={`sidebar-wrapper desktop-only ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <Sidebar
          closeSidebar={closeSidebar}
          isCollapsed={isSidebarCollapsed}
          toggleCollapse={toggleSidebarCollapse}
        />
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title={null}
        placement="left"
        onClose={closeSidebar}
        open={isSidebarOpen}
        closable={false}
        width={280}
        bodyStyle={{ padding: 0 }}
        className="mobile-drawer"
      >
        <div className="sidebar">
          <SidebarContent
            closeSidebar={closeSidebar}
            isCollapsed={false}
            toggleCollapse={toggleSidebarCollapse}
            isMobile={true}
          />
          <div className="sidebar-footer">
            {user && (
              <>
                <div className="sidebar-user-info">
                  <Avatar
                    size={40}
                    icon={<UserOutlined />}
                    style={{ backgroundColor: 'var(--blue-600)' }}
                  />
                  <div className="sidebar-user-details">
                    <div className="sidebar-user-name">{user.name}</div>
                    <div className="sidebar-user-email">{user.email}</div>
                  </div>
                </div>
                <Button
                  type="text"
                  icon={<LogoutOutlined />}
                  onClick={handleLogout}
                  className="sidebar-logout-button"
                  block
                >
                  Logout
                </Button>
              </>
            )}
          </div>
        </div>
      </Drawer>

      <div className="main-content">
        <Header onMenuClick={toggleSidebar} />
        <main>{children}</main>
      </div>
    </div>
  );
};

export default Layout;

